"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.XHR = void 0;
const core_1 = require("../core");
const XHRResponse_1 = require("../xhr/XHRResponse");
const XHRBase_1 = require("./XHRBase");
const parallelRequestManager_1 = require("../parallelRequestManager");
class XHR extends XHRBase_1.XHRBase {
    constructor(options) {
        super(options);
        this.parallelRequestManager = new parallelRequestManager_1.ParallelRequestManager();
    }
    GET(urlRaw, xhrOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            const { url, headers } = this.getRequestParams(xhrOptions, urlRaw);
            const responseParams = this.getResponseParams(xhrOptions);
            const fetchCall = () => __awaiter(this, void 0, void 0, function* () {
                const pluginResult = yield this.pluginHandleRequest({
                    method: 'GET',
                    mode: 'cors',
                    headers,
                    url,
                    signal: xhrOptions === null || xhrOptions === void 0 ? void 0 : xhrOptions.signal,
                });
                return fetch(pluginResult.url, pluginResult);
            });
            const originCall = () => __awaiter(this, void 0, void 0, function* () {
                const response = yield fetchCall();
                const xhrResponse = yield XHRResponse_1.XHRResponse.create(response, responseParams, { fetchCall, originCall });
                return this.makeResponse(xhrResponse);
            });
            return this.parallelRequestManager.handleRequest(originCall, urlRaw, xhrOptions);
        });
    }
    // TODO REQUEST_TYPE
    POST(url, body, xhrOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.commonPost('POST', url, body, xhrOptions);
        });
    }
    PUT(url, body, xhrOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.commonPost('PUT', url, body, xhrOptions);
        });
    }
    PATCH(url, body, xhrOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.commonPost('PATCH', url, body, xhrOptions);
        });
    }
    DELETE(url, body, xhrOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.commonPost('DELETE', url, body, xhrOptions);
        });
    }
    commonPost(method, urlRaw, body, xhrOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            const { url, headers } = this.getRequestParams(xhrOptions, urlRaw);
            const responseParams = this.getResponseParams(xhrOptions);
            const [sanitizedHeaders, sanitizedBody] = this.sanitizeHeadersAndBody(headers, body);
            core_1.Log.info('Calling fetch with ', sanitizedBody instanceof FormData ? 'FormData' : sanitizedBody instanceof URLSearchParams ? 'URLSearchParams' : 'JSON');
            const fetchCall = () => __awaiter(this, void 0, void 0, function* () {
                const options = yield this.pluginHandleRequest({
                    method,
                    mode: 'cors',
                    body: sanitizedBody,
                    headers: sanitizedHeaders,
                    url,
                    signal: xhrOptions === null || xhrOptions === void 0 ? void 0 : xhrOptions.signal,
                });
                core_1.Log.info('and with this options', JSON.stringify(options));
                return fetch(options.url, Object.assign({}, options));
            });
            const originCall = () => __awaiter(this, void 0, void 0, function* () {
                const response = yield fetchCall();
                const xhrResponse = yield XHRResponse_1.XHRResponse.create(response, responseParams, {
                    originCall,
                    fetchCall,
                });
                return this.makeResponse(xhrResponse);
            });
            return originCall();
        });
    }
}
exports.XHR = XHR;
//# sourceMappingURL=xhr.js.map